module.exports = __webpack_public_path__ + "static/img/title-bg.0caa4552.png";